var map = {
	"./corn_leaf_color_map.jpg": 198,
	"./cotton_leaf_color_map.jpg": 4867,
	"./cucumber_leaf_color_map.jpg": 66,
	"./lettuce_leaf_color_map.jpg": 7364,
	"./peanut_leaf_color_map.jpg": 2096,
	"./potato_leaf_color_map.jpg": 6819,
	"./soy_leaf_color_map.jpg": 2995,
	"./tomato_leaf_color_map.jpg": 4090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6021;